export default function CurrencyFormat(value) {
  const uang = new Intl.NumberFormat("de-DE").format(value);
  return uang;
}
